import { formatMonthYear, handleWebmotorsPrice } from "@/helpers/utils";
import { ResultSectionProps } from "@/interfaces/result";
import { Anotation } from "../anotation/anotation.component";

interface WebmotorsAveragesProps {
    prices: ResultSectionProps['pricesFormatted']['wm'];
    isVehicle0km: boolean
    isVehicleArmored: boolean
}

export const WebmotorsAverages = ({ isVehicle0km, isVehicleArmored, prices }: Readonly<WebmotorsAveragesProps>) => {
    const { hasArmored, isStateArmored, stateMediumPriceArmored, brazilianMediumPrice, stateMediumPrice, isBrazilianArmored } = handleWebmotorsPrice(prices, isVehicleArmored);

    if (
        isVehicle0km && stateMediumPrice ||
        (isVehicleArmored && !hasArmored) ||
        (!stateMediumPrice && !brazilianMediumPrice) ||
        (stateMediumPrice?.length == 0 && brazilianMediumPrice?.length == 0)
    ) {
        return <Anotation text="Não temos ofertas suficientes para o cálculo do valor Webmotors" />;
    }

    if (isVehicleArmored) {
        if (isStateArmored) {
            return (
                <>
                    <span data-testid="wm-price" id="wm-price">{stateMediumPriceArmored}</span>
                    <small id="ref-month" data-testid="fipe-price-ref-month">
                        Mês de referência: {prices.ref_month ? formatMonthYear(prices.ref_month) : 'N/A'}
                    </small>
                </>
            );
        }
        if (!isStateArmored && isBrazilianArmored) {
            return (
                <>
                    <span data-testid="wm-price" id="wm-price">{brazilianMediumPrice}</span>
                    <small id="ref-month" data-testid="fipe-price-ref-month">
                        Mês de referência: {prices.ref_month ? formatMonthYear(prices.ref_month) : 'N/A'}
                    </small>
                </>
            );
        }
    }

    if ((!stateMediumPrice || stateMediumPrice.length === 0) && (!!brazilianMediumPrice)) {
        return (
            <>
                <span data-testid="wm-price" id="wm-price">{brazilianMediumPrice}</span>
                <small id="ref-month" data-testid="fipe-price-ref-month">
                    Mês de referência: {prices.ref_month ? formatMonthYear(prices.ref_month) : 'N/A'}
                </small>
            </>
        );
    }

    return (
        <>
            <span data-testid="wm-price" id="wm-price">{stateMediumPrice}</span>
            <small id="ref-month" data-testid="fipe-price-ref-month">
                Mês de referência: {prices.ref_month ? formatMonthYear(prices.ref_month) : 'N/A'}
            </small>
        </>
    );
};